import React from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_NAME, ROUTES } from '../constants';
import { useTranslation } from '../contexts/TranslationContext';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__content">
          <p className="footer__copyright">
            © {currentYear} {APP_NAME}. {t.footer.rights}
          </p>
          <nav className="footer__nav">
            <button className="footer__link" onClick={() => navigate(ROUTES.GENERATOR)}>
              {t.nav.generator}
            </button>
          </nav>
        </div>
        <div className="footer__legal">
          <button
            className="footer__legal-link"
            onClick={() => navigate(ROUTES.PRIVACY_POLICY)}
          >
            {t.footer.privacyPolicy}
          </button>
          <span className="footer__legal-sep">·</span>
          <button
            className="footer__legal-link"
            onClick={() => navigate(ROUTES.TERMS_OF_SERVICE)}
          >
            {t.footer.termsOfService}
          </button>
          <span className="footer__legal-sep">·</span>
          <button
            className="footer__legal-link"
            onClick={() => navigate(ROUTES.HOW_PAYOUTS_WORK)}
          >
            {t.footer.howPayoutsWork}
          </button>
          <span className="footer__legal-sep">·</span>
          <button
            className="footer__legal-link"
            onClick={() => navigate(ROUTES.COOKIE_POLICY)}
          >
            {t.footer.cookiePolicy}
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
